export enum AttachmentSource {
    Local = 1,
    YouTube = 2,
    GoogleDrive = 0
  }
  